<!-- Page head -->
<div class="page-head">
  <div>
    <div class="page-head__title">{{ "transactions.listHeading" | transloco }}</div>
    <div class="page-head__sub">{{ "transactions.pageSubtitle" | transloco }}</div>
  </div>
  <div class="page-head__actions">
    <app-button
      buttonType="secondary"
      [text]="'transactions.refresh' | transloco"
      (click)="refresh()"
    ></app-button>
  </div>
</div>

<!-- Pending highlight -->
<div class="card pending-card" *ngIf="pendingCount() > 0">
  <div class="pending-card__inner">
    <div class="feed-icon feed-icon--warn">
      <mat-icon fontSet="material-icons-round">schedule</mat-icon>
    </div>
    <div class="pending-card__body">
      <div class="pending-card__title">{{ pendingTitle() }}</div>
      <div class="pending-card__sub">
        {{ "transactions.pendingSubtitle" | transloco }}
      </div>
    </div>
    <app-button
      [isBtnSmall]="true"
      [text]="'transactions.pendingReview' | transloco"
      (click)="showPending()"
    ></app-button>
  </div>
</div>

<!-- Filters -->
<div class="filters">
  <div class="filter-search">
    <mat-icon fontSet="material-icons-round">search</mat-icon>
    <input
      type="text"
      [formControl]="searchControl"
      [placeholder]="'transactions.searchPlaceholder' | transloco"
    />
  </div>

  <button class="filter-pill" type="button" [matMenuTriggerFor]="statusMenu">
    {{ "transactions.filterStatus" | transloco }}:
    <strong>{{ statusFilterLabel() }}</strong>
    <mat-icon fontSet="material-icons-round">expand_more</mat-icon>
  </button>
  <mat-menu #statusMenu="matMenu">
    <button mat-menu-item (click)="setStatusFilter(null)">
      {{ "transactions.filterAll" | transloco }}
    </button>
    <button
      mat-menu-item
      *ngFor="let status of statusList"
      (click)="setStatusFilter(status)"
    >
      {{ "transactions.statusChip." + status | transloco }}
    </button>
  </mat-menu>

  <button class="filter-pill" type="button" [matMenuTriggerFor]="typeMenu">
    {{ "transactions.filterType" | transloco }}:
    <strong>{{ typeFilterLabel() }}</strong>
    <mat-icon fontSet="material-icons-round">expand_more</mat-icon>
  </button>
  <mat-menu #typeMenu="matMenu">
    <button mat-menu-item (click)="setTypeFilter(null)">
      {{ "transactions.filterAll" | transloco }}
    </button>
    <button
      mat-menu-item
      *ngFor="let type of typeList"
      (click)="setTypeFilter(type)"
    >
      {{ "transactions." + type | transloco }}
    </button>
  </mat-menu>

  <button class="filter-pill" type="button" [matMenuTriggerFor]="programMenu">
    {{ "transactions.filterProgram" | transloco }}:
    <strong>{{ programFilterLabel() }}</strong>
    <mat-icon fontSet="material-icons-round">expand_more</mat-icon>
  </button>
  <mat-menu #programMenu="matMenu">
    <button mat-menu-item (click)="setProgramFilter(null)">
      {{ "transactions.filterAllPrograms" | transloco }}
    </button>
    <button
      mat-menu-item
      *ngFor="let program of programList()"
      (click)="setProgramFilter(program)"
    >
      {{ program.displayName }}
    </button>
  </mat-menu>

  <button class="filter-pill" type="button" [matMenuTriggerFor]="periodMenu">
    {{ "transactions.filterPeriod" | transloco }}:
    <strong>{{ periodFilterLabel() }}</strong>
    <mat-icon fontSet="material-icons-round">expand_more</mat-icon>
  </button>
  <mat-menu #periodMenu="matMenu">
    <button mat-menu-item (click)="setPeriodFilter(null)">
      {{ "transactions.filterAll" | transloco }}
    </button>
    <button
      mat-menu-item
      *ngFor="let period of periodList"
      (click)="setPeriodFilter(period)"
    >
      {{ "transactions.period." + period | transloco }}
    </button>
  </mat-menu>
</div>

<!-- Empty state — on true-empty show only the placeholder (no table/footer) -->
<app-empty-state
  *ngIf="!loading && transactionsData()?.length === 0"
  icon="receipt_long"
  heading="transactions.emptyTitle"
  message="transactions.noTransactions"
></app-empty-state>

<!-- Table -->
<div class="tbl-frame" *ngIf="transactionsData()?.length > 0">
  <div class="tbl-scroll">
    <table class="tbl">
      <thead>
      <tr>
        <th>{{ "transactions.customer" | transloco }}</th>
        <th>{{ "transactions.program" | transloco }}</th>
        <th>{{ "transactions.type" | transloco }}</th>
        <th>{{ "transactions.invoice" | transloco }}</th>
        <th class="num" *ngIf="showAmountColumn()">
          {{ "transactions.amount" | transloco }}
        </th>
        <th class="num">{{ "transactions.points" | transloco }}</th>
        <th>{{ "transactions.statusColumn" | transloco }}</th>
        <th>{{ "transactions.dateColumn" | transloco }}</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr
        *ngFor="let transaction of transactionsData()"
        class="tbl__row"
        (click)="openDetails(transaction)"
      >
        <td>
          <div class="u-user">
            <div
              class="u-user__av"
              [style.background]="avatarColor(transaction.email)"
            >
              {{ avatarInitials(transaction.email) }}
            </div>
            <div>
              <div class="u-user__name">{{ transaction.email || "—" }}</div>
              <div class="u-user__sub" *ngIf="!isLoyaltyEnded(transaction)">
                {{ "transactions.loyaltyPoints" | transloco }}
                <app-lomy-points
                  [value]="transaction.loyaltyPoints"
                  [inheritColor]="true"
                ></app-lomy-points>
              </div>
              <div class="u-user__sub" *ngIf="isLoyaltyEnded(transaction)">
                {{ "customers.ENDED" | transloco }}
              </div>
            </div>
          </div>
        </td>
        <td>{{ transaction.loyalty?.loyaltyProgram?.displayName || "—" }}</td>
        <td>
          <div class="tx-kind">
            <img
              *ngIf="isCouponKind(transaction) && transaction.image; else kindIcon"
              class="tx-kind__img"
              [src]="backendUrl + transaction.image"
              [alt]="transaction.couponName || ''"
            />
            <ng-template #kindIcon>
              <mat-icon fontSet="material-icons-round">{{
                transactionKindIcon(transactionKind(transaction))
              }}</mat-icon>
            </ng-template>
            <div class="tx-kind__text">
              <span class="tx-kind__label">{{
                "transactions.kind." + transactionKind(transaction) | transloco
              }}</span>
              <span class="tx-kind__sub" *ngIf="transaction.couponName">{{
                transaction.couponName
              }}</span>
            </div>
          </div>
        </td>
        <td>{{ transaction.invoiceNo || "—" }}</td>
        <td class="num" *ngIf="showAmountColumn()">
          {{
            transactionKind(transaction) === 'INVOICE_SCAN'
              ? (formatAmount(transaction) || "—")
              : "—"
          }}
        </td>
        <td class="num">
          <span class="tbl__points" *ngIf="showsPoints(transaction)">
            <app-lomy-points
              [value]="transaction.points"
              [prefix]="transaction.points > 0 ? '+' : ''"
            ></app-lomy-points>
          </span>
          <span class="tbl__points--none" *ngIf="!showsPoints(transaction)"
            >—</span
          >
        </td>
        <td>
          <span class="chip" [ngClass]="statusChipClass(transaction.status)">
            {{ "transactions.statusChip." + transaction.status | transloco }}
          </span>
        </td>
        <td class="tbl__date">{{ formatCreated(transaction) }}</td>
        <td>
          <div class="row-actions">
            <ng-container *ngIf="isPending(transaction); else notPending">
              <button
                class="primary"
                type="button"
                (click)="acceptTransaction(transaction, $event)"
              >
                {{ "transactions.approve" | transloco }}
              </button>
              <button
                type="button"
                (click)="openCancelModal(transaction, $event)"
              >
                {{ "transactions.declineTransaction" | transloco }}
              </button>
            </ng-container>
            <ng-template #notPending>
              <button
                *ngIf="isCancellable(transaction)"
                type="button"
                (click)="openCancelModal(transaction, $event)"
              >
                {{ "transactions.cancelTransaction" | transloco }}
              </button>
            </ng-template>
          </div>
        </td>
      </tr>
    </tbody>
      </table>
  </div>

  <!-- Pagination footer -->
  <div class="tbl-foot">
    <div class="tbl-foot__label">
      {{
        "transactions.rangeLabel"
          | transloco
            : { from: rangeFrom(), to: rangeTo(), total: totalElements() }
      }}
    </div>
    <div class="tbl-foot__nav">
      <app-button
        buttonType="secondary"
        [isBtnSmall]="true"
        [disabled]="!hasPreviousPage()"
        [text]="'transactions.previousPage' | transloco"
        (click)="previousPage()"
      ></app-button>
      <app-button
        buttonType="secondary"
        [isBtnSmall]="true"
        [disabled]="!hasNextPage()"
        [text]="'transactions.nextPage' | transloco"
        (click)="nextPage()"
      ></app-button>
    </div>
  </div>
</div>

<!-- Paginator kept alive (hidden) OUTSIDE the table frame so its paging state
     (length/pageIndex) survives leaving and returning to the list; the prev/next
     buttons above are the visible control. -->
<mat-paginator
  class="paginator-hidden"
  [pageSize]="pageSize"
  [hidePageSize]="true"
  (page)="onPageChange($event)"
></mat-paginator>

<app-spinner [enableSpinner]="loading"></app-spinner>

<!-- Decline / cancel with message -->
<app-modal-custom
  #cancelTransactionModal
  [titleText]="'transactions.cancelTransactionHeading' | transloco"
  [cancelButtonShown]="true"
  [cancelButtonText]="'global.cancel' | transloco"
  [saveButtonText]="'transactions.declineTransaction' | transloco"
  (onModalSave)="cancelTransaction(); cancelTransactionModal.closeModal()"
>
  <p class="text--error">
    {{ "transactions.cancelTransactionText" | transloco }}
  </p>
  <p>{{ "transactions.cancelInfoUserText" | transloco }}</p>

  <div class="field">
    <label class="field__label">{{
      "transactions.cancelTransactionMessage" | transloco
    }}</label>
    <div class="field__input field__input--textarea">
      <textarea
        rows="3"
        [(ngModel)]="cancelTransactionMessage"
        [ngModelOptions]="{ standalone: true }"
      ></textarea>
    </div>
  </div>
</app-modal-custom>
